//basic
import React from 'react';
import { toJS } from 'mobx';
import { observer, inject } from 'mobx-react';

//api
import { api } from '../../../functions/api';

//custom components
import CustomInput from '../../../components/basic/input';
import CustomButton from '../../../components/basic/CustomButton';
import CustomAvatar from '../../../components/basic/customAvatar';
import SelectSearch from '../../../components/basic/SelectSearch/SelectSearch';

//material-ui
import { Dialog, DialogTitle, DialogContent, DialogActions, FormControl, InputLabel, MenuItem, Select, Button, ListItem, CircularProgress } from '@material-ui/core';

//style
import './AddEditFixedSet.scss';

// import image from '../../../assets/image/image.png';
import image from '../../../assets/image/svg/logo.svg';
import { throws } from 'assert';


@inject('translate')
@inject('internal')
@observer
export default class AddEditFixedSet extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            loadingBtn: false,
            data: [],
            selected: [],
            name: "",
            // discount: "",
            production: true,
            page_title: "",
            page_description: "",
            alias: ""
        }
    }

    isEditMode = null;

    componentDidMount() {

        this.isEditMode = toJS(this.props.internal.actionEdit);
        let listAllProducts = toJS(this.props.internal.dataForTable.lists.products) //pomocna premena kde ukladam data, potrebujem premenovat na value/label
        let newListProducts = []
        for (let product in listAllProducts) {
            newListProducts.push({
                value: listAllProducts[product].id,
                label: listAllProducts[product].name
            })
        }
        this.setState({ data: newListProducts })

        if (this.isEditMode.edit) {
            //load detail fixneho setu
            this.loadFixedSet()
        }
        else {
            this.setState({ loading: false })
        }
    }

    fixedSetData = {}
    loadFixedSet = async () => {
        let idFixedSet = toJS(this.props.internal.actionEdit.id)
        // let idFixedSet = 2;
        let load_fixed_set = await api({
            method: 'get',
            url: `products/static-sets/${idFixedSet}`,
            authorization: this.props.internal.user.access_token,
        })

        if (load_fixed_set.success) {
            this.fixedSetData = load_fixed_set.data.data;
            let selected = load_fixed_set.data.data.products;
            for (let i in selected) {
                selected[i].label = selected[i].name
                selected[i].value = selected[i].id
            }
            this.editCategory = load_fixed_set.data.data
            this.setState({
                loading: false,
                name: load_fixed_set.data.data.name,
                // discount: load_fixed_set.data.data.discount,
                selected: selected,
                production: load_fixed_set.data.data.production,
                page_title: load_fixed_set.data.data.page_title,
                page_description: load_fixed_set.data.data.page_description,
                alias: load_fixed_set.data.data.alias,
            })
        }
    }

    action = () => {
        let isEdit = toJS(this.props.internal.actionEdit.edit)
        this.setState({ loadingBtn: true })
        if (isEdit) {
            //update
            this.updateFixedSet()
        }
        else {
            //create
            this.createFixedSet()
        }
    }

    updateFixedSet = async () => {
        let name = this.name.state.value
        // let discount = this.discount.state.value
        if (name !== "") {
            let idFixedSet = toJS(this.props.internal.actionEdit.id)

            // TODO: vymazat ked budu testovacie data
            // idFixedSet = 2;

            let update_data = await api({
                method: 'patch',
                url: `products/static-sets/${idFixedSet}`,
                authorization: this.props.internal.user.access_token,
                params: {
                    name: name,
                    shop_id: this.props.shop_id,
                    page_title: this.page_title.state.value,
                    page_description: this.page_description.state.value,
                    production: this.state.production,
                    alias: this.alias.state.value

                }
            })

            if (update_data.success === true) {
                // this.props.internal.setSnackbar(update_data.data.message, true)
                // this.props.onClose(true)
                this.setProductsForFixedSet(idFixedSet)
            } else {
                if (update_data.data.data.hasOwnProperty('errors')) {
                    const firstKey = Object.keys(update_data.data.data.errors).shift();
                    this.props.internal.setSnackbar(update_data.data.data.errors[firstKey][0], true);
                } else {
                    this.props.internal.setSnackbar(update_data.data.message, true)
                }
                this.setState({ loadingBtn: false })
            }
        }
        else {
            this.props.internal.setSnackbar(this.props.translate.i18n.GLOBAL.ALERTS.FILL_REQUIRED_INPUTS, true)
            this.setState({ loadingBtn: false })
        }

    }

    createFixedSet = async () => {
        let name = this.name.state.value
        // let discount = this.discount.state.value
        // if(name !== "" && discount !== "") {
        if (name !== "") {
            this.setState({ loadingBtn: true })
            let update_data = await api({
                method: 'post',
                url: `products/static-sets`,
                authorization: this.props.internal.user.access_token,
                params: {
                    name: name,
                    page_title: this.page_title.state.value,
                    page_description: this.page_description.state.value,
                    production: this.state.production,
                    shop_id: this.props.shop_id,
                    alias: this.alias.state.value
                }
            })

            if (update_data.success === true || (update_data.success === false && update_data.status === 201)) {
                // this.props.internal.setSnackbar(update_data.data.message, true)
                this.setProductsForFixedSet(update_data.data.data.id)
                // this.props.onClose(true)
            }
        }
        else {
            this.props.internal.setSnackbar(this.props.translate.i18n.GLOBAL.ALERTS.FILL_REQUIRED_INPUTS, true)
            this.setState({ loadingBtn: false })
        }

    }

    setProductsForFixedSet = async (idFixedSet) => {
        //TODO: vymazat ked budu na testovacom serveri
        // idFixedSet = 2

        let ids = this.state.selected;
        ids = ids.map(item => item.value)
        let update_data = await api({
            method: 'patch',

            //TODO: vymazat ked budu na testovacom serveri
            // postman: true,

            url: `products/static-sets/${idFixedSet}/products`,
            authorization: this.props.internal.user.access_token,
            params: {
                ids: ids
            }
        })

        if (update_data.success === true) {
            this.setState({ loadingBtn: false })
            this.props.internal.setSnackbar(update_data.data.message, true)
            this.props.onClose(true)
        }
    }

    handleChangeCheckbox = (event) => {
        this.setState({ production: event.target.checked })
    }

    onSelectChange = (val) => {
        this.setState({ selected: val })
    }

    handleChangePhoto = async (data) => {


        let idFixedSet = toJS(this.props.internal.actionEdit.id)

        if (idFixedSet !== null) {
            this.setState({ loadingBtn: true })
            let upload_data = await api({
                method: 'post',
                url: `products/static-sets/${idFixedSet}`,
                formData: true,
                authorization: this.props.internal.user.access_token,
                params: {
                    image: data,
                    shop_id: this.props.shop_id
                },

            })

            if (upload_data.success && upload_data.success === true) {
                // this.props.internal.photoWasChanged(false)
                this.props.internal.setSnackbar(upload_data.data.message, true)
                this.setState({ loadingBtn: false })
                return Promise.resolve(false)
            }
            else {
                this.props.internal.setSnackbar(upload_data.data.message, true)
            }
        }
        else {

        }
    }


    timeout2 = null
    still = true

    handleSuggestAliasFromAlias = (param) => {
        // if (this.isEmpty(this.editCategory)) {
        if (this.alias.state.value !== "")  {
            clearTimeout(this.timeout2)
            this.timeout2 = setTimeout(() => {
                this.aliasSuggestion(param)
            }, 500)
        }
        else if (this.name.state.value === "") {
            this.alias.setValue("")
        }
    }
    handleSuggestAlias = (param) => {
        // if (this.isEmpty(this.editCategory)) {
        if (this.name.state.value !== "")  {
            clearTimeout(this.timeout2)
            this.timeout2 = setTimeout(() => {
                this.aliasSuggestion(param)
            }, 500)
        }
        else if (this.name.state.value === "") {
            this.alias.setValue("")
        }
    }

    aliasSuggestion = async (param) => {
        let params = ""
        if(param === 'name'){
            params = this.name.state.value
        }else if (param === 'alias') {
            params = this.alias.state.value
        }
        let alias_suggestion = await api({
            method: 'POST',
            url: 'products/static-sets/suggest-slug',
            authorization: this.props.internal.user.access_token,
            params: {
                name: params,
            }
        })

        if (alias_suggestion.success === true) {
            this.alias.setValue(alias_suggestion.data.data.alias)
        }
    }

    isEmpty(obj) {
        for (var key in obj) {
            if (obj.hasOwnProperty(key))
                return false;
        }
        return true;
    }

    editCategory = {};

    render() {

        return (
            <Dialog
                open={this.props.open}
                onClose={() => this.props.onClose(false)}
                aria-labelledby="form-dialog-title"
                classes={{
                    root: "addEditFixedSetDialog-root",
                    paper: "addEditFixedSetDialog-paper"
                }}
              scroll={'body'}
            >
                <DialogTitle id="form-dialog-title">{this.props.title}</DialogTitle>
                {this.state.loading
                    ?
                    <div style={{ minHeight: "100px" }}>
                        <CircularProgress className={'circular-progress'} />
                    </div>
                    :
                    <DialogContent classes={{ root: "add-fixed-set-content" }}>
                        <div className={'set-image'}>
                            <CustomAvatar
                                src={this.fixedSetData.image ? this.fixedSetData.image : image}
                                // disableEdit={idAdmin === loggedUserId ? false : true}
                                actionUploadPhoto={this.handleChangePhoto}
                            />
                        </div>
                        <CustomInput
                            ref={ref => this.name = ref}
                            text={this.props.translate.i18n.MODULES['FIXED-SETS'].TITLE}
                            // value={this.props.idCategory ? this.editCategory.name : ""}
                            // value=""
                            value={this.state.name}
                            change={()=>this.handleSuggestAlias('name')}
                            id={'title'}
                            className={"w-100"}
                        // required
                        />
                        <SelectSearch
                            options={this.state.data}
                            // onChange={this.onParentSelectChange}
                            onChange={val => this.onSelectChange(val)}
                            value={this.state.selected}
                            className={'select-search'}
                            label={this.props.translate.i18n.MODULES['FIXED-SETS'].PRODUCTS}
                            isMulti={true}
                        />
                        {/* <div className={'seoData'}> */}
                            <CustomInput
                                ref={ref => this.page_title = ref}
                                text={this.props.translate.i18n.MODULES['FIXED-SETS'].PAGE_TITLE}
                                // value={this.props.idCategory ? this.editCategory.name : ""}
                                // value=""
                                value={this.state.page_title}
                                id={'page_title'}
                                className={"w-100"}
                                // required
                            />
                            <CustomInput
                                ref={ref => this.page_description = ref}
                                text={this.props.translate.i18n.MODULES['FIXED-SETS'].DESCRIPTION}
                                // value={this.props.idCategory ? this.editCategory.name : ""}
                                // value=""
                                value={this.state.page_description}
                                id={'page_description'}
                                className={"w-100"}
                                // required
                                multiline
                            />
                            <CustomInput
                                ref={ref => this.alias = ref}
                                text={this.props.translate.i18n.MODULES['FIXED-SETS'].ALIAS}
                                // value={this.props.idCategory ? this.editCategory.name : ""}
                                // value=""
                                value={this.editCategory.alias}
                                // change={this.handleSuggestAlias}
                                change={()=>this.handleSuggestAliasFromAlias('alias')}
                                id={'alias'}
                                className={"w-100"}
                                // required
                                multiline
                            />
                        {/* </div> */}
                        <ListItem dense onChange={this.handleChangeCheckbox} className={'list-item'}>
                            <input
                                id={"production"}
                                type="checkbox"
                                value={this.state.production}
                                defaultChecked={
                                    // this.fixedSetData
                                    //     ? this.fixedSetData.production
                                    //     : false
                                    this.state.production
                                }
                            />
                            <label htmlFor={"production"}>{this.props.translate.i18n.GLOBAL.TABLE.ACTIVE}</label>
                        </ListItem>

                        {/* <FormControl className='parameter-type-selector w-100'>
                        <InputLabel className={'parameter-type-label'}>{this.props.translate.i18n.MODULES.PARAMETERS.CHOSE_PARAMETER_TYPE}</InputLabel>
                        <Select
                            className={'select-param-type'}
                            fullWidth
                            onChange={this.handleChangeParameterType}
                            value={this.state.parameterType}

                        >
                            <MenuItem value={0}>{this.props.translate.i18n.MODULES.PARAMETERS.PARAMETER_TYPES.ONE_PARAM}</MenuItem>
                            <MenuItem value={1}>{this.props.translate.i18n.MODULES.PARAMETERS.PARAMETER_TYPES.MULTIPLE_PARAMS}</MenuItem>
                            <MenuItem value={2}>{this.props.translate.i18n.MODULES.PARAMETERS.PARAMETER_TYPES.TEXT_PARAM}</MenuItem>
                        </Select>
                    </FormControl> */}
                    </DialogContent>
                }
                <DialogActions>
                    <Button onClick={() => this.props.onClose(false)} className={'gray-text'}>
                        {this.props.translate.i18n.GLOBAL.BUTTONS.CANCEL}
                    </Button>
                    <CustomButton
                        progressBar={this.state.loadingBtn}
                        onClick={this.action}
                        mystyle={'btn-white-bg'}
                        title={this.props.translate.i18n.GLOBAL.BUTTONS.SAVE}
                        justText
                        disabled={this.state.loading}
                    />
                </DialogActions>
            </Dialog>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/fixedSets/AddEdit/AddEditFixedSet.js